/* Intelligems test 'PDP callback position', all greenhouse PDPs (Nordwood, poly, glass, heritage), from 2026-10-01.
   Version A (control) = callback card BELOW the trust row, version B = ABOVE it, directly under the buy button.
   Intelligems injects, per version:  A: window.yghCbPos='A'; html.classList.add('ygh-cb-below')
                                      B: window.yghCbPos='B'; html.classList.add('ygh-cb-above')
   The order rules live in each hero's CSS (new-pdp-{nord,poly-wmp,glass,heritage}-hero.css). Without a class the
   hero keeps its template's block order.
   This file only measures: pdp_callback_click (card button), pdp_callback_submit (accepted HubSpot submission of a
   hero callback form), pdp_delivery_see_more (See more in the delivery line under the buy button), and it reports
   the version of a submitted lead to the lead relay, which adds a timeline note to the HubSpot lead.
   Preview without Intelligems: ?ygh-cb=a (below) / ?ygh-cb=b (above), kept for the session, never tagged onto leads.
   Loaded by every greenhouse hero section; the guard keeps it to one copy per page. */
(function () { if (window.__yghCbPosTest) return; window.__yghCbPosTest = true;
  var TEST = 'pdp_callback_position';
  var LABELS = { A: 'callback below the trust row', B: 'callback above the trust row' };
  var RELAY = 'https://ygh-lead-relay.raitislm.workers.dev/abtag';
  var preview = null;
  try {
    var m = /[?&]ygh-cb=([ab])\b/i.exec(location.search);
    if (m) sessionStorage.setItem('ygh_cb_preview', m[1].toLowerCase());
    preview = sessionStorage.getItem('ygh_cb_preview');
  } catch (e) {}
  if (preview) {
    document.documentElement.classList.toggle('ygh-cb-below', preview === 'a');
    document.documentElement.classList.toggle('ygh-cb-above', preview === 'b');
  }
  function version() { var v = String(window.yghCbPos || '').toUpperCase(); return LABELS[v] ? v : null; }
  function track(name) {
    try { window.igEvents = window.igEvents || []; window.igEvents.push({ event: name }); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: name, ygh_cb_version: version() || (preview ? 'preview-' + preview : '') }); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-callback-card]')) track('pdp_callback_click');
    /* the See more link in the delivery line under the buy button (opens the shipping drawer) */
    if (e.target && e.target.closest && e.target.closest('[data-npwmp-cta-note] .ship-more')) track('pdp_delivery_see_more');
  });
  function heroForm(id) {
    var hit = false;
    document.querySelectorAll('[data-callback-modal][id^="np-cb-"]').forEach(function (mo) { if (mo.getAttribute('data-callback-hs-form') === id) hit = true; });
    return hit;
  }
  document.addEventListener('hs-form-event:on-submission:success', function (e) {
    var id = (e.detail && e.detail.formId) || '';
    if (!id || !heroForm(id)) return;
    track('pdp_callback_submit');
    var v = version();
    if (!v || preview) return; /* not in the test (outside the audience) or a preview: nothing to tag */
    var api = window.HubSpotFormsV4, form = null;
    try { form = api && api.getFormFromEvent ? api.getFormFromEvent(e) : null; } catch (err) {}
    if (!form || !form.getFormFieldValues) return;
    Promise.resolve(form.getFormFieldValues()).then(function (values) {
      var email = '';
      (values || []).forEach(function (f) { var n = f && f.name ? String(f.name) : ''; if (n === 'email' || n.slice(-6) === '/email') email = Array.isArray(f.value) ? f.value[0] : f.value; });
      if (!email) return;
      var body = JSON.stringify({ email: email, test: TEST, variant: v, label: LABELS[v], form_id: id, page: location.pathname });
      fetch(RELAY, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {});
    }, function () {});
  });
})();
